var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0.1px",
    d: "M26.395 9.987a.827.827 0 0 0-.49.241l-14.3 14.3a.832.832 0 0 0-.223.4l-1.375 6.05a.826.826 0 0 0 .988.988l6.05-1.375a.819.819 0 0 0 .4-.223l14.3-14.3a.825.825 0 0 0 0-1.16l-4.675-4.675a.823.823 0 0 0-.679-.241zm.095 1.985L30 15.487 16.865 28.618l-3.506-3.506zM12.663 26.744l2.561 2.561-3.308.756z",
    transform: "translate(-8.987 -8.981)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.bb24fbf750442074bae18c3941b38f48.svg";
export { ForwardRef as ReactComponent };